import { IUnit } from 'types/entities';
import { EntityService } from '../entity.service';


class UnitsService extends EntityService<IUnit> {
  readonly entityName = 'unit';
}

export default new UnitsService();
